export default "__VITE_ASSET__Bmr$M9hx__"